import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from "vue-toastification/composition";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import i18n from "@/libs/i18n";
import store from "@/store";

export default function sectionListQuery() {
    const toast = useToast()
    const courseTable = ref(null)
    const perPage = ref(10)
    const totalCourses = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('start_date')
    const isSortDirDesc = ref(true)
    const sectionFilter = ref(null)
    const groupFilter = ref(null)
    const taxFilter = ref(null)
    const statusFilter = ref(true)
    const filteredCourses=ref(true)

    const groupOptions = ref([])
    const taxOptions = ref([])
    const sectionOptions = ref([])

    const tableColumns = ref([
        { key: 'course', label: i18n.t('Course'), sortable: true},
        { key: groupOptions.value.length > 1 ? 'group' : '', label: 'Sucursal', sortable: true },
        { key: 'places', label: 'Plazas restantes', sortable: true },
        { key: 'dates', label: i18n.t('Dates') },
        { key: 'status', label: i18n.t('Status'), sortable: true },
        { key: 'actions', label: i18n.t('Actions') },
    ])

    const dataMeta = computed(() => {
        const localItemsCount = courseTable.value ? courseTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalCourses.value,
        }
    });

    const refetchData = function() {
        courseTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, sectionFilter, groupFilter, taxFilter, statusFilter], () => {
        refetchData()
    })

    const fetchCourses = function(ctx, callback) {
        store.dispatch('courses/fetchCourses', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            section: sectionFilter.value,
            group: groupFilter.value,
            tax: taxFilter.value,
            status: statusFilter.value
        })
        .then(response => {
            const { courses, total, groups, sections, taxes } = response.data
            callback(courses)
            filteredCourses.value=courses
            groupOptions.value = groups
            tableColumns.value = [
                { key: 'course', label: i18n.t('Course'), sortable: true},
                { key: groupOptions.value.length > 1 ? 'group' : '', label: 'Sucursal', sortable: true },
                { key: 'places', label: 'Plazas restantes', sortable: true },
                { key: 'dates', label: i18n.t('Dates') },
                { key: 'status', label: i18n.t('Status'), sortable: true },
                { key: 'actions', label: i18n.t('Actions') },
            ]
                    sectionOptions.value = sections
            taxOptions.value = taxes
            totalCourses.value = total
        })
        .catch(error => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error al obtener el listado de cursos',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        fetchCourses,
        tableColumns,
        perPage,
        currentPage,
        totalCourses,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        courseTable,
        refetchData,
        sectionFilter,
        groupFilter,
        taxFilter,
        groupOptions,
        taxOptions,
        sectionOptions,
        statusFilter,
        filteredCourses
    }
}
